import * as DatetimeFields from 'notebook/data-tables/DatetimeFields';
import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';
import * as ExcessUtil from 'notebook/tables/excess/Util';
import {BaseTypedValueType, TypedValue} from 'notebook/tables/TableConstants';
import {coerceToPrimitive} from 'notebook/tables/typed-values/DataTypes';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';

const DATE_COERCABLE_TYPED_VALUE_TYPES: Array<string> = [
  FieldType.TEXT,
  FieldType.LONG_TEXT,
  BaseTypedValueType.STRING,
];

function coerce(typedValue: TypedValue, languageTag?: string | null): number | null {
  let result = coerceToPrimitive(typedValue, {
    shouldCoerceStringToNumber: true,
    shouldCoerceDateToNumber: true,
    languageTag,
  });
  if (typeof result === 'string' && DATE_COERCABLE_TYPED_VALUE_TYPES.includes(typedValue.type as string)) {
    const momentValue = DatetimeFields.tryParseAsMoment(result, languageTag ?? undefined);
    if (momentValue != null) {
      result = ExcessUtil.momentToDaysSinceEpoch(momentValue);
    }
  }
  return typeof result === 'number' ? result : null;
}

export default {
  name: 'DAYS',
  category: FunctionCategory.TIMESTAMP,
  shortDescription: 'Number of days between two dates.',
  description: 'Returns the number of days between two dates.',
  params: [
    {
      name: 'end_date',
      type: ArgType.any,
      description: 'The end date.',
      coerce,
    },
    {
      name: 'start_date',
      type: ArgType.any,
      description: 'The start date.',
      coerce,
    },
  ],
  returnType: ExcessUtil.ValueType.NUMBER,
  eval: (endDays: number | null, startDays: number | null): number => {
    if (endDays == null || startDays == null) {
      throw new ExcessUtil.ValueError('Both start and end dates must be valid dates or numbers');
    }
    return Math.floor(endDays - startDays);
  },
} satisfies EvaluablePrimitiveSpreadsheetFunction;
